<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'AdminDrivers',
  }
</script>
